import { Component, ContentChild, ViewEncapsulation } from '@angular/core';
import { TmModalComponent } from '../tm-modal/tm-modal.component';

@Component({
  selector: 'tm-modal-footer',
  templateUrl: './tm-modal-footer.component.html',
  styleUrls: ['./tm-modal-footer.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TmModalFooterComponent {
  @ContentChild('tmModalFooter', {static: true}) footerTemp: any;

  constructor(public modal: TmModalComponent) { }
}
